export const aliyunApi = {
  getEcsList: '/clouddm/console/api/v1/aliyun/ecs/listecs',
  addEcs: '/clouddm/console/api/v1/aliyun/ecs/ecsaddandinstall',
  getRdsList: '/clouddm/console/api/v1/aliyun/rds/listrds',
  querynetinfo: '/clouddm/console/api/v1/aliyun/rds/querynetinfo',
  installAliyunEcs: '/clouddm/console/api/v1/aliyun/ecs/install',
  uninstallAliyunEcs: '/clouddm/console/api/v1/aliyun/ecs/uninstall',
  upgradeAliyunEcs: '/clouddm/console/api/v1/aliyun/ecs/upgradeall',
  checkCloudDsAccount: '/clouddm/console/api/v1/aliyun/rds/checkclouddsaccount',
  queryWhiteList: '/clouddm/console/api/v1/aliyun/rds/querywhitelist',
  addClusterWhiteList: '/clouddm/console/api/v1/aliyun/rds/addclusterwhitelist'
};
